
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import { MessageBox } from "element-ui";
import Pagination from "@/comp/Pagination/index.vue";
import { whiteWordsList, whiteWordsSave, whiteWordsBatchAdd, whiteWordsRemove } from "@/api/request/system";
import { parseTime } from "@/utils";

//组件
@Component({
  name: "WhiteWordsList",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;
  private multipleSelection: Array<any> = [];

  //请求参数
  private listQuery: any = {
    //页码数据
    page: 1,
    page_size: 20,

    //上传数据
    word: "", // 敏感词
  };

  //创建
  created() {
    //获取数据
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await whiteWordsList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //清空数据
    this.multipleSelection = [];

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取数据
    this.getList();
  }

  //处理创建
  private handleCreate(): void {
    //数据赋值
    this.addForm = {
      words: [],
    };
    this.add_word_str = "";

    //显示界面
    this.addDialogVisible = true;
  }

  //批量删除
  private handleBatchDelete(): void {
    //数据赋值
    var ids: Array<number> = [];
    for (var i: number = 0; i < this.multipleSelection.length; i++) {
      ids.push(this.multipleSelection[i].id);
    }

    //显示提示
    MessageBox.confirm("批量删除操作不可恢复，确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //处理删除操作
        await whiteWordsRemove({ ids: ids });

        //显示提示
        this.$notify({
          title: "成功",
          message: "批量删除成功",
          type: "success",
          duration: 2000,
        });

        //清空数据
        this.multipleSelection = [];

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //处理删除
  private handleDelete(row: any): void {
    //显示提示
    MessageBox.confirm("删除操作不可恢复，确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //处理删除操作
        await whiteWordsRemove({ ids: [row.id] });

        //显示提示
        this.$notify({
          title: "成功",
          message: "删除成功",
          type: "success",
          duration: 2000,
        });

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //处理编辑
  private handleUpdate(row: any): void {
    //数据赋值
    this.editForm = {
      id: row.id,
      word: row.word,
    };

    //显示界面
    this.editDialogVisible = true;
  }

  //获取时间文本
  private getTimeStr(time: number): string {
    return parseTime(time) as string;
  }

  //选择
  private handleSelectionChange(val: Array<any>): void {
    //数据赋值
    this.multipleSelection = val;

    console.log(this.multipleSelection);
  }

  //--------------------------------- 编辑 ---------------------------------
  //定义变量
  private editDialogVisible: boolean = false;
  private editDialogLoading: boolean = false;

  //添加表单
  private editForm: any = {
    id: 0, // ID
    word: "", //敏感词
  };

  //更新敏感词
  private async handleEdit() {
    //数据处理
    if (this.editForm.value == "") return this.$message.error("请输入敏感词");

    //显示等待
    this.editDialogLoading = true;

    //保存数据
    await whiteWordsSave(this.editForm);

    //隐藏等待
    this.editDialogLoading = false;

    //隐藏界面
    this.editDialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "编辑成功",
      type: "success",
      duration: 2000,
    });

    //获取列表
    this.getList();
  }

  //--------------------------------- 批量添加 ---------------------------------
  //定义变量
  private add_word_str: string = "";
  private addDialogVisible: boolean = false;
  private addDialogLoading: boolean = false;

  //添加表单
  private addForm: any = {
    words: [], //敏感词
  };

  //更新敏感词
  private async handleAdd() {
    //数据处理
    if (this.add_word_str == "") return this.$message.error('请输入敏感词，用“,"隔开');

    //显示等待
    this.addDialogLoading = true;

    //数据赋值
    this.addForm.words = this.add_word_str.split(",");

    //保存数据
    await whiteWordsBatchAdd(this.addForm);

    //隐藏等待
    this.addDialogLoading = false;

    //隐藏界面
    this.addDialogVisible = false;

    //显示提示
    this.$notify({
      title: "成功",
      message: "批量添加成功",
      type: "success",
      duration: 2000,
    });

    //获取列表
    this.getList();
  }
}
